import { render, staticRenderFns } from "./ListEmptyMessage.vue?vue&type=template&id=70c6f69c&scoped=true&"
import script from "./ListEmptyMessage.vue?vue&type=script&lang=ts&"
export * from "./ListEmptyMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ListEmptyMessage.vue?vue&type=style&index=0&id=70c6f69c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c6f69c",
  null
  
)

export default component.exports